import React, {use, useEffect} from 'react'
import { Grid } from '@mui/material'

import PageWrapper from 'Pages/@PageWrapper'
import { TourProvider, TourTarget } from "@tour"
import { CUSTOM_DASHBOARD_PRIMOR_ROUTES } from '@constants/routes'
import {isSystemBusy} from "@signals";
import {isEmptyFlashOffers, resetFlashOffersSignals} from "./@signals";
import CustomDashboardsPrimorFlashOffers from "./Offers"
import FlashOffersFormDrawer from "./ReportForm";


export default function FlashOffersPage() {

    useEffect(() => {
        return () => resetFlashOffersSignals()
    }, [])

    const props = {
        actions: null,
        tourPageKey: "flashOffers",
        head: CUSTOM_DASHBOARD_PRIMOR_ROUTES.FLASH_OFFERS_TITLE,
        title: CUSTOM_DASHBOARD_PRIMOR_ROUTES.FLASH_OFFERS_TITLE,
        subtitle: CUSTOM_DASHBOARD_PRIMOR_ROUTES.FLASH_OFFERS_SUBTITLE,
        isEmpty: isEmptyFlashOffers.value,
        hasErrors: isSystemBusy.value
    }

    return <PageWrapper {...props} >
        <Grid item xs={12} sx={{ position: "relative" }}>
            <TourTarget name="flash-offers-table" height={350} />
            <CustomDashboardsPrimorFlashOffers />
        </Grid>
       <FlashOffersFormDrawer />
    </PageWrapper>
}